import { EditChatMessageForm } from 'types/chats';
import { useChatsState } from 'hooks/chats/useChatsState';

export const useEditChatMessageForm = (): null | EditChatMessageForm => {
  const { editChatMessageForm } = useChatsState();

  return editChatMessageForm;
};
